import { StackActions, useNavigation, useRoute } from '@react-navigation/core'
import * as React from 'react'
import { useEffect } from 'react'
import { useLazyApiData, useStores } from '../../data/store'
import { Screens } from '../../nav/Screens'
import { EnterOtpComp } from './EnterOtpComp'

export const EnterMobileOtpScreen = () => {
  const navigation = useNavigation()
  const { validateCustomerOTP, sendOTPToCustomerMobile } = useStores((root) => ({
    validateCustomerOTP: root.customer.validateCustomerOTP,
    sendOTPToCustomerMobile: root.customer.sendOTPToCustomerMobile,
  }))
  const routes: any = useRoute()

  const mobileNo = routes.params?.mobileNo

  React.useEffect(() => {
    navigation.setOptions({ headerTitle: 'Link Aadhar' })
  }, [navigation])

  const [validateCustomerOTPApi, validateOtpHandler] = useLazyApiData(validateCustomerOTP)

  const [sendOTPToCustomerMobileApi, sendOTPToCustomerMobileHandler] = useLazyApiData(sendOTPToCustomerMobile)

  const onOtpSubmit = (otp: string) => {
    validateCustomerOTPApi(otp, mobileNo)
  }
  useEffect(() => {
    if (validateOtpHandler.state === 'fulfilled') {
      navigation.dispatch(
        StackActions.replace(Screens.ENTER_CUSTOMER_AADHAAR as never, {
          mobileNo,
          ...routes?.params,
        }),
      )
    }
  }, [mobileNo, navigation, routes, validateOtpHandler])

  return (
    <EnterOtpComp
      onOtpSubmit={onOtpSubmit}
      isLoading={validateOtpHandler.state === 'pending'}
      title="Please enter 6-digit OTP"
      subTitle={`A 6-digit one time password is sent to the customer\nregistered mobile number (xxxxxx${mobileNo.slice(
        -4,
      )}).`}
      buttonTitle="Verify"
      onResendOTPPress={() => {
        sendOTPToCustomerMobileApi(mobileNo)
      }}
      resendOtpState={sendOTPToCustomerMobileHandler?.state}
    />
  )
}
